// extracted by mini-css-extract-plugin
module.exports = {"authModalWrapper":"Auth_authModalWrapper__aNjBv","authModal":"Auth_authModal__PoaNT","authTrouble":"Auth_authTrouble___AFr_","skeleton-loading":"Auth_skeleton-loading__okM9D"};